import { TranslateService, TranslateStore } from '@ngx-translate/core';

declare module '@ngx-translate/core' {
  interface TranslateService {
    readonly translations: Record<string, any>;
  }
}

export function patchTranslateServiceCompat(translateService: TranslateService, translateStore: TranslateStore): void {
  if (Object.getOwnPropertyDescriptor(translateService, 'translations')) {
    return;
  }

  const translationsProxy = new Proxy({} as Record<string, any>, {
    get: (_, lang: string | symbol) => {
      if (typeof lang !== 'string') {
        return undefined;
      }

      return translateStore.getTranslations(lang);
    },
  });

  Object.defineProperty(translateService, 'translations', {
    configurable: true,
    enumerable: false,
    get: () => translationsProxy,
  });
}
